import { httpRequest } from "@services/http";

export interface FieldChoice {
  value: string;
  label: string;
}

export interface Field {
  id: number;
  name: string;
  display_name: string;
  field_type: string;
  choices?: FieldChoice[];
  dimension_keys?: string[];
  // Dimension dicts observed in the org's data — the picker's validated choices (MPN-1202).
  dimensions?: Record<string, string>[];
  // Display name per catalog code, per axis (MPN-1663): shown in the picker,
  // never stored — the rule carries the code.
  dimension_value_names?: Record<string, Record<string, string>>;
}

export interface Entity {
  id: number;
  name: string;
  display_name: string;
  lookup_prefix: string;
  fields: Field[];
}

export interface AudienceSchemaResponse {
  organization_id: number;
  entities: Entity[];
}

export class CommandGetEntities {
  async run(organizationId: number, audienceId: number | null = null): Promise<Entity[]> {
    const base = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/audiences/organizations/${organizationId}/configs/`;
    const url = audienceId != null ? `${base}?audience_definition_id=${audienceId}` : base;

    const response = await httpRequest<AudienceSchemaResponse>(url, {
      method: "GET",
    });

    return response.entities;
  }
}